/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeviceInfoRequest } from '../models/DeviceInfoRequest';
import type { ShopRequest } from '../models/ShopRequest';
import type { ShopView } from '../models/ShopView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MobileUserService {
    /**
     * Update device info
     * Add or update device info for current user
     * @param requestBody
     * @returns any Device info updated
     * @throws ApiError
     */
    public static putAppMobileUserDeviceInfoUpdate(
        requestBody: DeviceInfoRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/api/mobile/user/device-info',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
            },
        });
    }
    /**
     * List user shops
     * Get all registered shops for current user
     * @returns ShopView List of shops
     * @throws ApiError
     */
    public static getAppMobileUserShopList(): CancelablePromise<Array<ShopView>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/mobile/user/shop/list',
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Get shop by ID
     * Get shop settings by ID for current user
     * @param shopId
     * @returns ShopView Shop data
     * @throws ApiError
     */
    public static getAppMobileUserShopGet(
        shopId: string,
    ): CancelablePromise<ShopView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/mobile/user/shop',
            query: {
                'shopID': shopId,
            },
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Update shop
     * Updates one shop of the current user. Every field is optional and only what the caller sends is written, so a client changing notification preferences alone can post just shopId and notifications. Subusers may change nothing but their own notifications.
     * @param requestBody
     * @returns ShopView Updated shop, including the stored notifications
     * @throws ApiError
     */
    public static putAppMobileUserShopUpdate(
        requestBody: ShopRequest,
    ): CancelablePromise<ShopView> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/api/mobile/user/shop',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error`,
                403: `Scheduled reports are not included in the current plan`,
                404: `Shop not found`,
            },
        });
    }
    /**
     * Add shop
     * Add shop for current user
     * @param requestBody
     * @returns ShopView Shop added
     * @throws ApiError
     */
    public static postAppMobileUserShopAdd(
        requestBody: ShopRequest,
    ): CancelablePromise<ShopView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/mobile/user/shop',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Delete shop
     * Delete shop by ID for current user
     * @param shopId
     * @returns any Shop deleted
     * @throws ApiError
     */
    public static deleteAppMobileUserShopDelete(
        shopId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/api/mobile/user/shop',
            query: {
                'shopID': shopId,
            },
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Create user
     * Create user profile with optional initial shops
     * @param requestBody Array of initial shops (optional)
     * @returns any User created
     * @throws ApiError
     */
    public static postAppMobileUserCreate(
        requestBody?: Array<ShopRequest>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/mobile/user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Delete user
     * Delete current user and all data associated with them
     * @returns any User deleted
     * @throws ApiError
     */
    public static deleteAppMobileUserDelete(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/api/mobile/user',
            errors: {
                400: `Error`,
            },
        });
    }
}
